import { useCallback, useMemo, useState } from 'react';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers';
import { useAccountId } from '@atlassian/jira-tenant-context-controller';

const COMPASS_COMPONENTS_NAMESPACE = 'compass-components';

type ControllerResult = [{ hasBeenViewed: boolean }, { hide: () => void; reset: () => void }];

export function useCompassComponentsSpotlightViewed(): ControllerResult {
	const accountId = useAccountId();
	const storageKey = `spotlight-viewed-${accountId}`;
	const storage = useMemo(() => createLocalStorageProvider(COMPASS_COMPONENTS_NAMESPACE), []);
	const [hasBeenViewed, setHasBeenViewed] = useState<boolean>(storage.get(storageKey));

	const hide = useCallback(() => {
		setHasBeenViewed(true);
		storage.set(storageKey, true);
	}, [setHasBeenViewed, storage, storageKey]);

	const reset = useCallback(() => {
		setHasBeenViewed(false);
		storage.remove(storageKey);
	}, [setHasBeenViewed, storage, storageKey]);

	return [
		{
			hasBeenViewed,
		},
		{
			hide,
			reset,
		},
	];
}
